<template>
	<div class="dingdan">
<!--		<breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'订单管理(上海)'}]" v-if="firstPageFlag!=1"/>-->
    <Breadtabsheader/>
		<div class="h-piece h-mrt30 margin">
			<div class="h-formBox">
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
					<div class="h-thirdColumn w-newColumn">
						<el-form-item label="订单编号" prop="sapCode" style="width: 50%;">
							<el-input v-model="formInline.sapCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
						</el-form-item>
						<el-form-item label="创建时间" prop="cdatebegin" style="width: 50%;">
							<el-date-picker
									v-model="formInline.cdatebegin"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
							</el-date-picker>
							<span class="w-time-to">至</span>
							<el-date-picker
									v-model="formInline.cdateend"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
							</el-date-picker>
						</el-form-item>
					</div>
					<el-collapse-transition>
						<div v-show="isScreen">
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="　创建人编码/名称" prop="cuserCodeNameLike">
									<el-input v-model="formInline.cuserCodeNameLike" placeholder="请输入"
											  style="width: 100%"></el-input>
								</el-form-item>

								<el-form-item label="　订单类型" prop="orderCategory1">
									<el-select v-model="formInline.orderCategory1" clearable placeholder="请选择" style="width:100%">
										<el-option v-for="item in orderCategory1List"
												   :key="item.code"
												   :label="item.name"
												   :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="　售达方编码/名称" prop="sdfCodeNameLike">
									<el-input v-model="formInline.sdfCodeNameLike" placeholder="请输入"
											  style="width: 100%"></el-input>
								</el-form-item>
								<el-form-item label="订单状态" prop="status">
									<brselect clearable category="order_status" :v="formInline.status"
											  v-model="formInline.status"></brselect>
								</el-form-item>
							</div>
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="销售组织" prop="saleGroupCode">
									<brselect category="xiaoshou_zuzhi" :v="formInline.saleGroupCode"
											  v-model="formInline.saleGroupCode" clearable></brselect>
								</el-form-item>

								<!--
								<el-form-item label="订单类型" prop="orderCategory">
									<brselect category="xiaoshou_quyu" :v="formInline.orderCategory"
											  v-model="formInline.orderCategory" clearable
											  @change="changeOrderCate"
									></brselect>
								</el-form-item>
								-->

								<el-form-item label="是否手动收货" v-auth="'caiwushouhuo'" prop="shouhuoflag">
									<brselect clearable category="shifou_keyong" :v="formInline.shouhuoflag"
											  v-model="formInline.shouhuoflag"></brselect>
								</el-form-item>
								<el-form-item label="自产 /OEM" prop="prodtype">
									<el-select v-model="formInline.prodtype" :clearable="true"
											   placeholder="请选择">
										<el-option label="自产" value="自产"></el-option>
										<el-option label="OEM" value="OEM"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="　产品编码/名称" prop="materialCodeNameLike">
									<el-input v-model="formInline.materialCodeNameLike" placeholder="请输入"></el-input>
								</el-form-item>
							</div>
							<div class="h-thirdColumn w-newColumn">

								<el-form-item prop="ownShenpiFlag" class="clstyle">
									<el-switch
											v-model="formInline.ownShenpiFlag"
											active-text="只看我的审批"
											inactive-text="查看所有"
											@change="ownShenpiFlag()">
									</el-switch>
								</el-form-item>


							</div>
						</div>
					</el-collapse-transition>
				</el-form>
				<div class="l-screenBox">
					<div class="l-screen" @click="collapseChange">
						<img :src="isScreen?closeScreen:drawScreen" alt="">
						<div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
					</div>
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
						</el-button>
						<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
								   @click="imgfalse3" v-if="firstPageFlag!=1">
							新建订单
						</el-button>
						<el-button v-auth="'caiwushouhuo'" class="h-btn h-formBtn h-bggreen"
								   @click="caiwushouhuo">
							收货
						</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="h-table h-mrt30 tableclslist">
			<el-table
					ref="ddtable"
					:data="tableData"
					:span-method="objectSpanMethod"
					@selection-change="handleSelectionChange"
					stripe
					border
					:show-overflow-tooltip="true"
					style="width: 100%"
					max-height="500"
			>
				<el-table-column
						type="selection"
						fixed
						width="40">
				</el-table-column>
				<el-table-column
						type="index"
						fixed
						label="#"
						width="40">
				</el-table-column>
				<el-table-column
						fixed
						prop="sapCode"
						label="订单号"
						:show-overflow-tooltip="true"
						width="120">
				</el-table-column>
				<el-table-column
						prop="soldToName"
						label="售达方名称"
						fixed
						:show-overflow-tooltip="true"
						width="180">
					<template scope="scope">
						<div style="text-align: left;">
							{{scope.row.soldToName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="materialName"
						label="产品名称"
						fixed
						:show-overflow-tooltip="true"
						width="140">
					<template scope="scope">
						<div style="text-align: left;">
							{{scope.row.materialName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="proNumber"
						label="数量"
						width="60">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.proNumber}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="note"
						label="备注"
						:show-overflow-tooltip="true"
						min-width="190">
					<template scope="scope">
						<div style="text-align: left;">
							{{scope.row.note}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="cwddh"
						label="客户订单号"
						:show-overflow-tooltip="true"
						min-width="190">
					<template scope="scope">
						<div style="text-align: left;">
							{{scope.row.cwddh}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="prodtype"
						label="自产/OEM"
						width="110">
				</el-table-column>
				<el-table-column
						prop="materialCode"
						label="产品编码"
						:show-overflow-tooltip="true"
						width="120">
				</el-table-column>
				<el-table-column
						prop="status"
						label="订单状态"
						:show-overflow-tooltip="true"
						width="110">
					<template scope="scope">
						{{scope.row.status|dictname('order_status')}}
					</template>
				</el-table-column>



				<el-table-column
						prop="orderCategory"
						label="订单类型"
						:show-overflow-tooltip="true"
						width="110">
					<template scope="scope">
						{{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
					</template>
				</el-table-column>
				<el-table-column
						prop="specialOfferCode"
						label="特价版本号"
						:show-overflow-tooltip="true"
						width="180">
				</el-table-column>
				<el-table-column
						prop="saleGroupCode"
						label="销售组织"
						:show-overflow-tooltip="true"
						width="260">
					<template scope="scope">
						<div style="text-align: left;">
							[{{scope.row.saleGroupCode}}]{{scope.row.saleGroupCode|dictname('YLSalesOrganization_agent')}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="soldToCode"
						label="售达方编码"
						:show-overflow-tooltip="true"
						width="120">
				</el-table-column>

				<el-table-column
						prop="soldToAreaName"
						label="售达方地区"
						:show-overflow-tooltip="true"
						width="110">
				</el-table-column>
				<!--<el-table-column-->
				<!--prop="currencyCode"-->
				<!--label="币种编码"-->
				<!--width="110">-->
				<!--</el-table-column>-->
				<el-table-column
						prop="disChannelCode"
						label="分销渠道编码"
						:show-overflow-tooltip="true"
						width="120">
					<template scope="scope">
						{{scope.row.disChannelCode|dictname('fenxiao_qudao')}}
					</template>
				</el-table-column>
				<el-table-column
						prop="customerChannelCode"
						label="客户渠道"
						:show-overflow-tooltip="true"
						width="90">
					<template scope="scope">
						{{scope.row.customerChannelCode|dictname('sales_region')}}
					</template>
				</el-table-column>
				<el-table-column
						prop="orderProjectName"
						label="项目名称"
						:show-overflow-tooltip="true"
						width="180">
					<template scope="scope">
						<div style="text-align: left;">
							{{scope.row.orderProjectName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="cuname"
						label="创建人名称"
						:show-overflow-tooltip="true"
						width="110">
				</el-table-column>
				<el-table-column
						prop="cdate"
						label="创建时间"
						width="160">
				</el-table-column>

				<el-table-column
						prop="toCompanyname"
						label="收货单位"
						:show-overflow-tooltip="true"
						width="180">
					<template scope="scope">
						<div style="text-align: left;">
							{{scope.row.toCompanyname}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="contactName"
						label="收货联系人"
						width="110">
				</el-table-column>

				<!--<el-table-column-->
				<!--prop="wldw"-->
				<!--label="单位"-->
				<!--width="70">-->
				<!--</el-table-column>-->
				<el-table-column
						prop="finalPrice"
						label="成交价"
						:show-overflow-tooltip="true"
						width="80">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.finalPrice}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="totalprice"
						label="总价"
						:show-overflow-tooltip="true"
						width="90">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.totalprice}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="jinejjz"
						label="不含税总价"
						:show-overflow-tooltip="true"
						width="110">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.jinejjz}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="totalprice"
						label="汇算总价"
						:show-overflow-tooltip="true"
						width="100">
					<template scope="scope">
						<div style="text-align: right;">
							{{scope.row.totalprice}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						fixed="right"
						label="操作"
						width="260"
				>
					<template slot-scope="scope">
						<div style="text-align: left;">
							<div v-if="scope.row.status == '10'" style="text-align: left;">
								<el-button
										v-if="_user.usercode == scope.row.cucode || adminFlag"
										size="small" class="h-tableLink h-btn"
										@click="handleEdit(scope.row)">编辑
								</el-button>
								<el-button
										v-if="_user.usercode == scope.row.cucode || adminFlag"
										size="small" class="h-tableLink h-btn"
										@click="sapDeleteOrder2(scope.row)">删除
								</el-button>
								<!-- <div class="l-operationBox">
									<span class="l-operationlist br-operation-xg" title="编辑订单" @click="handleEdit(scope.row)"></span>
									<span class="l-operationlist br-operation-delete" title="删除订单" @click="sapDeleteOrder2(scope.row)"></span>
								</div> -->
							</div>
							<div v-else style="text-align: left;">
								<el-button v-if="scope.row.binstid"
										   size="small" class="h-tableLink h-btn"
										   @click="genzongLiuch(scope.row)">
									跟踪
								</el-button>
								<el-button
										size="small" class="h-tableLink h-btn"
										@click="handelDetail(scope.row)">查看
								</el-button>
								<el-button
										v-if="scope.row.status < 50"
										v-auth="'zuofeidingdan'"
										size="small" class="h-tableLink h-btn"
										@click="sapDeleteOrder(scope.row)">作废
								</el-button>

								<el-button
										v-if="scope.row.status == 30"
										size="small" class="h-tableLink h-btn"
										@click="sapDeleteOrder2(scope.row)">删除
								</el-button>

								<el-button
										v-if="_user.usercode == scope.row.cucode && scope.row.status < 50"
										size="small" class="h-tableLink h-btn"
										@click="sapCHOrder(scope.row)">撤回
								</el-button>
								<span v-if="_user.usercode == scope.row.cucode">
									<el-button
											v-if="scope.row.shenpiflag"
											size="small" class="h-tableLink h-btn"
											@click="shenpiopt(scope.row, '1')">
									提报
									</el-button>
								</span>
								<span v-else>
									<el-button
											v-if="scope.row.shenpiflag"
											size="small" class="h-tableLink h-btn"
											@click="shenpiopt(scope.row, '')">
									审批
									</el-button>
								</span>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
				<pagination :page="formInline" @query="query"/>
				<div style="display:flex;align-items: center;">
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
							   @click="exportExcel">批量导出
					</el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
							   @click="uploaddownexcelflagbtn">批量导入
					</el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ" v-auth="'shanghai_dayinfadan'"
							   @click="shanghai_dayinfadan">打印发货单</el-button>
				</div>
				<uploaddownexcel
						:visible.sync="uploaddownexcelflag"
						v-if="uploaddownexcelflag"
						clsname="viewOrderShanghaiImportExcel"
						:startrow="5" @callback="uploadExcelFilecallback"/>
			</div>
		</div>


		<!--创建订单弹出框-->
		<dingdadd :visible.sync="imgflag3" v-if="imgflag3" @imgfalse3="imgflag3=false"/>

		<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>


		<el-dialog :close-on-click-modal="false" title="作废订单" :visible.sync="zfyydialogFormVisible">
			<el-form :model="zuofeiyy">
				<el-form-item label="作废原因" :label-width="100">
					<brselect category="DD_ZFYY" :v="zuofeiyy.yy"
							  v-model="zuofeiyy.yy" ></brselect>
				</el-form-item>
				<el-form-item label="备注" :label-width="100">
					<el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submitzuofei">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="撤回订单" :visible.sync="chehuidialogFormVisible">
			<el-form :model="zuofeiyy">
				<el-form-item label="撤回原因" :label-width="100">
					<brselect category="DD_ZFYY" :v="zuofeiyy.yy"
							  v-model="zuofeiyy.yy" ></brselect>
				</el-form-item>
				<el-form-item label="备注" :label-width="100">
					<el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="撤单申请书" class="h-elformWrap-2" :rules="[
                  { required: true, message: '请上传撤单申请书', trigger: 'change'},
                ]">
					<brupload
							:refid="refid"
							reftype="订单-撤单申请书"
							:limit="1"
							:showtime="false"
							uploadflag
							delflag
					>
					</brupload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="chehui">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="order.showOrderNxSp"
				   v-if="order.showOrderNxSp"
				   v-on="$listeners"
				   :modal-append-to-body='false'
				   append-to-body
				   title="上海订单"
				    :close-on-click-modal="false"
				   width="90%" class="showflowDialogcls">
			<ordershsp
					@refreshSelf="refreshSelf"
					:orderid="order.orderid"
					:orderinstid="order.orderinstid"
					:ordertaskid="order.ordertaskid"
					:ordertaskstatus="order.ordertaskstatus"
			/>
		</el-dialog>
	</div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
    export default {
        props: ["firstPageFlag"],
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //导入Excel
                uploaddownexcelflag: false,

                fjCode: null,
                fhStatus: null,
                refid: null,
                reftype: null,

                instid: null,
                showhistory: null,
                adminFlag:false,
                imgflag3: false,
                orderTypeList: [],
                orderCategory1AllList:[],
                orderCategory1List:[],

                tableData: [],
                //用户项目
                allProjectByUser: [],
                //是否有项目
                xiangmuTab: false,
                //销售组织，下拉
                xszz: [],
                fxqd: [],
                //表单
                formInline: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    ownShenpiFlag: false,
                    ownShenpi: '',
                    cuserCodeNameLike: "",
                    sdfCodeNameLike: "",
					materialCodeNameLike:"",
                    orderCategory: "3",
                    saleGroupCode: "",
                    status: "",
                    cdatebegin:null,
                    cdateend:null,
                    orderTypebz: 1,
                    shouhuoflag:null,
                    prodtype:null,
                },
                spanArr: [],
                //作废原因
                zfyydialogFormVisible:false,
                //撤回
                chehuidialogFormVisible: false,
                zuofeiyy:{
                    id:null,
                    yy:null,
                    bz:null,
                },

                tableSelectedList:[],

                order:{
                    showOrderNxSp:false,
                    showOrderWxSp:false,
                    orderid:"",
                    orderinstid:"",
                    ordertaskid:"",
                    ordertaskstatus:"",
                },
            }
        },

        created() {
            this.query();
            this.adminFlag = this.$store.getters.hasRole('swyl_admin');
            this.orderCategory1AllList=this.$store.getters.dictlist("xiaoshou_quyu_nwx");
            //    项目
            //     this.listPro();

            console.log("tttttttttttttt", this.orderCategory1AllList);
            this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:'20191025GIFP5q9A'});

        },
        methods: {
            //打印发货单
            shanghai_dayinfadan(){
                if(this.tableSelectedList.length==0)  {
                    this.$msg.msge( "至少选择一条销售单打印！");
                    return;
                }
                var ids = _.map(this.tableSelectedList,"bid").join(",");
                window.open(process.env.VUE_APP_AJAXURL+"/api/swyl/v1/dingd/bsc/OrderCg/showfh?frompage=1&codes="+ids)
            },
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            refreshSelf(params){
                if(params && params.close){
                    this.order.showOrderNxSp = false;
                }
                if(params && params.refresh){
                    this.query();
                }
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },

            changeOrderCate(cate){
                if(cate){
                    this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:cate.id});
                }else{
                    this.orderCategory1List =  [];
                }

            },
			caiwushouhuo(){

			},
            shenpiopt(row, flag){
				console.log("row::",row)
                var instid = null;
                if (row.orderCategory == '1') {
                    instid = row.binstid;
                } else {
                    instid = row.instid;
                }
                if(flag=="1"){
                    this.$router.push({
                        path: row.dburl,
                        query: {ywid: row.bid,taskid:row.taskid, instid: instid, taskstatus: '0', chongXinTiJiao: flag}
                    })
                    return;
                }
                this.order.orderid=row.id;
                this.order.orderinstid=instid;
                this.order.ordertaskstatus='0';
                this.order.ordertaskid=row.taskid;
                this.order.showOrderNxSp = true;
                return;
            },
            //批量导出
            exportExcel() {
                var strids = _.join(_.map(this.tableSelectedList,"bid"),",");
                var form = {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    ownShenpiFlag: false,
                    ownShenpi: '',
                    cuserCodeNameLike: "",
                    sdfCodeNameLike: "",
					materialCodeNameLike:"",
                    orderCategory: "",
                    saleGroupCode: "",
                    status: "",
                    cdatebegin:null,
                    cdateend:null,
                    orderTypebz: 1,
                    shouhuoflag:null,
                    prodtype:null,
                };
                if (strids == '') {
                    form = _.clone(this.formInline);
                }
                form.strids = strids;
                updownfile.down("/api/swyl/v1/demo/viewOrderShanghai/downloadExcel", form, "post");
            },

            ownShenpiFlag(){
                if(this.formInline.ownShenpiFlag){
                    this.formInline.ownShenpi = '1';
                }else {
                    this.formInline.ownShenpi = '';
                }
            },

            //财务收货
            handleSelectionChange(lists){
                this.tableSelectedList = lists;
            },

            getSpanArr() {
				this.spanArr = [];
				this.tableData.forEach((item0, index0) => {
					console.log(item0)
					let bIdStr = "";
					let statusStr = "";
					let fahuoStrFlag =false;
					//遍历当前表元素
					this.tableData.forEach((item, index) => {
						if(item0.id === item.id){
							bIdStr += item.bid+",";
							statusStr += item.status+",";
							// if(item.fahuoStr){
							// 	fahuoStrFlag=true;
							// }
						}				
						
					})
					item0.bIdStr=bIdStr.substring(0,bIdStr.length-1);
					item0.cstatusStr=statusStr.substring(0,statusStr.length-1);
					//item0.cfahuoStrFlag=fahuoStrFlag;
					console.log(bIdStr.substring(0,bIdStr.length-1))
					console.log(item0)
				})
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].id === this.tableData[index - 1].id) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (
                    (column.property == 'orderCategory')
                    ||
                    (column.property == 'soldToCode')
                    ||
                    (column.property == 'soldToName')
                    ||
                    (column.property == 'disChannelCode')
                    ||
                    (column.property == 'orderProjectName')
                    ||
                    (column.property == 'customerChannelCode')
                    ||
                    (column.property == 'soldToAreaName')
                    ||
                    (column.property == 'toCompanyname')
                    ||
                    (column.property == 'contactName')
                    ||
                    (column.property == 'cuname')
                    ||
                    (column.property == 'cdate')
                    ||
                    (
                        (column.label == '订单状态' || column.label == '操作') &&
                        (row.status == '10' )
                    )||
                    (
                        (column.label == '操作') &&
                        (row.orderCategory == '3' )
                    )
                ) {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            genzongLiuch(r) {
                this.instid = r.binstid;
                this.showhistory = true;
            },
            imgfalse3() {
                this.imgflag3 = true;
            },
            //查询该用户及所有子用户所有订单详情
            query() {
                ss.OrderMainService.selectDingdanPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    this.formInline.total = rd.total || 0;
                    console.log(this.tableData,"进来了");
                    this.getSpanArr();
                });
            },

            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },

            // 重置按钮
            resetData() {
                this.formInline.sapCode = "";
                this.formInline.ownShenpiFlag = false;
                this.formInline.ownShenpi = "";
                this.formInline.cuserCodeNameLike = "";
                this.formInline.sdfCodeNameLike = "";
				this.formInline.materialCodeNameLike = "";
                this.formInline.orderCategory = "3";
                this.formInline.orderCategory1 = "";
                this.formInline.saleGroupCode = "";
                this.formInline.status = "";
                this.formInline.cdatebegin = null;
                this.formInline.cdateend = null;
                this.formInline.orderTypebz = 1;
                this.formInline.shouhuoflag = null;
                this.formInline.prodtype = null;
            },


            handleEdit(row) {
                this.toEdit(row.orderCategory, row.orderCategory1, row.id);
            },
            handelDetail(row) {
                var instid = null;
                if (row.orderCategory == '3') {
                    instid = row.binstid!=null?row.binstid:row.instid;
                } else {
                    instid = row.instid;
                }
                if (row.orderCategory == '1') {
                    this.order.orderid=row.bid;
                    this.order.orderinstid=instid;
                    this.order.ordertaskstatus='1';
                    this.order.showOrderNxSp = true;
                    return;
                } else {
                    this.$router.push({
                        path: "/dingdmain/orderShshenpi",
                        query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                    });
                }
            },

            cancel(){
                this.chehuidialogFormVisible = false;
                this.zfyydialogFormVisible = false;
                this.zuofeiyy = {
                    id:null,
                    yy:null,
                    bz:null,
                };
            },

            //作废订单
            sapDeleteOrder(row) {
                if (row.status == '10') {
                    this.$msg.confirm("确认作废?", () => {
                        ss.OrderMainService.sapDeleteOrderSh(row.id, row.deleteReason).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                } else {
                    this.zuofeiyy.id = row.id
                    this.zfyydialogFormVisible = true;
                }
            },

            //删除订单
            sapDeleteOrder2(row) {
                if (row.status == '10' || row.status == '30') {
                    this.$msg.confirm("确认删除?", () => {
                        ss.OrderMainService.sapDeleteOrderSh2(row.id, row.deleteReason).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                } else {
                    this.zuofeiyy.id = row.id
                    this.zfyydialogFormVisible = true;
                }
            },

            submitzuofei(){
                if (!this.zuofeiyy.yy) {
                    this.$msg.msge("请选择作废原因");
                    return false;
                }
                var yybz = this.zuofeiyy.yy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy.yy)+":"+this.zuofeiyy.bz;
                this.$msg.confirm("确认作废?", () => {
                    ss.OrderMainService.sapDeleteOrderSh(this.zuofeiyy.id, yybz).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                        this.zfyydialogFormVisible = false;
                        this.zuofeiyy = {
                            id:null,
                            yy:null,
                            bz:null,
                        };
                    });
                });
            },
            //撤回订单
            sapCHOrder(row) {
				console.log("row::",row);
                this.$msg.confirm("确认从SAP作废并撤回订单?", () => {
                    this.zuofeiyy.id = row.id
                    this.chehuidialogFormVisible = true;
                    this.refid = row.bid;
                });
            },
            chehui(){
                if (!this.zuofeiyy.yy) {
                    this.$msg.msge("请选择撤回原因");chehuidialogFormVisible
                    return false;
                }
                var yybz = this.zuofeiyy.yy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy.yy)+":"+this.zuofeiyy.bz;
                this.$msg.confirm("确认撤回?", () => {
                    ss.OrderMainService.sapCHOrderSh(this.zuofeiyy.id, yybz).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                        this.chehuidialogFormVisible = false;
                        this.zuofeiyy = {
                            id:null,
                            yy:null,
                            bz:null,
                        };
                    });
                });
            },
            toEdit(ddlx, ddzlx, id) {
                //上海直销
                this.$router.push({path: "/dingd/createShanghOrder", query: {id: id}})
            },
        },

        mounted() {

        },

    }
</script>
<style scoped>
	.xiangmu .h-piece, .h-mrt30 {
		margin: 20px;
	}

	.h-formBtnOut .h-mr20 {
		margin-left: 1rem !important;
	}

	.D-date .el-cascader {
		line-height: 0;
	}
	.tableclslist	.h-tableLink{
		padding:0px 2px!important;
	}
</style>
